
export default {
	xs: ' ',
	s: ' ',
	nb: ' ',
	l: ' ',
}